var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0570374,
    y: 0.138428,
    width: 43.4971,
    height: 43.4971,
    rx: 10.8743,
    fill: "#E7FAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6499 14.4109C13.2746 14.4109 12.9703 14.7152 12.9703 15.0905V16.4498C12.9703 16.8252 13.2746 17.1295 13.6499 17.1295H15.0092C15.3846 17.1295 15.6888 16.8252 15.6888 16.4498V15.0905C15.6888 14.7152 15.3846 14.4109 15.0092 14.4109H13.6499ZM15.0092 15.0905H13.6499V16.4498H15.0092V15.0905Z",
    fill: "#0DCAF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7278 15.7702C17.7278 15.3948 18.0321 15.0905 18.4074 15.0905H30.641C31.0163 15.0905 31.3206 15.3948 31.3206 15.7702C31.3206 16.1455 31.0163 16.4498 30.641 16.4498H18.4074C18.0321 16.4498 17.7278 16.1455 17.7278 15.7702Z",
    fill: "#0DCAF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4074 20.5277C18.0321 20.5277 17.7278 20.832 17.7278 21.2073C17.7278 21.5827 18.0321 21.887 18.4074 21.887H30.641C31.0163 21.887 31.3206 21.5827 31.3206 21.2073C31.3206 20.832 31.0163 20.5277 30.641 20.5277H18.4074Z",
    fill: "#0DCAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4074 25.9648C18.0321 25.9648 17.7278 26.2691 17.7278 26.6445C17.7278 27.0198 18.0321 27.3241 18.4074 27.3241H30.641C31.0163 27.3241 31.3206 27.0198 31.3206 26.6445C31.3206 26.2691 31.0163 25.9648 30.641 25.9648H18.4074Z",
    fill: "#0DCAF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9703 20.5277C12.9703 20.1523 13.2746 19.848 13.6499 19.848H15.0092C15.3846 19.848 15.6888 20.1523 15.6888 20.5277V21.887C15.6888 22.2623 15.3846 22.5666 15.0092 22.5666H13.6499C13.2746 22.5666 12.9703 22.2623 12.9703 21.887V20.5277ZM13.6499 20.5277H15.0092V21.887H13.6499V20.5277Z",
    fill: "#0DCAF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6499 25.2852C13.2746 25.2852 12.9703 25.5895 12.9703 25.9648V27.3241C12.9703 27.6995 13.2746 28.0037 13.6499 28.0037H15.0092C15.3846 28.0037 15.6888 27.6995 15.6888 27.3241V25.9648C15.6888 25.5895 15.3846 25.2852 15.0092 25.2852H13.6499ZM15.0092 25.9648H13.6499V27.3241H15.0092V25.9648Z",
    fill: "#0DCAF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrants);
export default __webpack_public_path__ + "static/media/registrants.04be86b2872f3efba2c7f24e2a5e4ca5.svg";
export { ForwardRef as ReactComponent };